<div class="modal-content-container">
    <a id="close-dialog-alta" class="close-dialog" (click)="closeDialog()">
      <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
    </a>
    
    <div class="modal-title" style="text-align: center;">
        <div class="mt-2">
            <img class="icon" [src]="imagenModal">
        </div>
    </div>
    
    <div class="modal-title">
      <div class="title margin-fix">
        {{tituloModal}}
      </div>
    </div>
    <div [ngClass]="classMessage">
        {{mensajeModal}}
    </div>
  </div>
